/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EnvelopeRegularReport from './envelope-regular-report-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EnvelopeRegularReport {...validProps} />;
}

SvgComponent.iconName = 'envelopeRegularReport';

export const EnvelopeRegularReportIcon = svgIconWrapper(SvgComponent);
